import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from '@/plugins/vuetify';
import moment from 'moment';
import trans from './trans';
import Messages from './components/Messages';

import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/dist/vuetify.min.css';
import './scss/main.scss';
Vue.config.productionTip = false;
Vue.component('messages', Messages);

Vue.prototype.moment = (timestamp) => moment(timestamp);
Vue.prototype.trans = trans;
new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
  created() {
    store.dispatch('locale/setLocale');
  },
}).$mount('#app');
